import * as S from './PromoCodeSelector.styles'
import { translateManager as t } from '../../../services/TranslateManager'

function And() {
  return (
    <S.Ands>
      <S.AndLineLeft />
      <S.And>{t.get('login.terms_of_use.and')}</S.And>
      <S.AndLineRight />
    </S.Ands>
  )
}

export default And
